import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    SHOW_MESSAGE,
    INIT_URL,
    SET_SOCKET
  } from "../types";
import axios from "../../services/Api";
import history from "../../services/history";
import { showToast } from "../../services/functions";
import { lsSet } from '../../utils/hooks';
  
  
export const setInitUrl = (url) => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const dummyAction = (url) => {
  return {
    type: "DUMMY",
    payload: "shavika"
  };
};

export const userLogin = (payload, callback) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    axios
      .post('users/login', {
        ...payload,
      })
      .then(({ data }) => {
        if (data.success) {
          if (data.twoFactorAuth === true) {
            axios.defaults.headers.common['authorization'] = data.resendOtpToken;
            dispatch({ type: FETCH_SUCCESS, payload: data });
            if (callback) callback(data, null);
          } else if (data.requiresConsent === true) {
            // No token yet — backend returns sessionId; consent must be confirmed first
            dispatch({ type: FETCH_SUCCESS, payload: data });
            if (callback) callback(data, null);
          } else {
            // Complete login process for non-2FA, consented cases
            afterLoginProcess();
            dispatch({ type: FETCH_SUCCESS, payload: data });
            if (callback) callback(data, null);
          }
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.message });
          // showToast(data.message, true);
          if (callback) callback(null, data.message);
        }

        function afterLoginProcess() {
          lsSet("token", data.token);
          lsSet("user", data.user);
          axios.defaults.headers.common['authorization'] = data.token;
          dispatch({ type: FETCH_SUCCESS });
          // setTimeout(() => { history.push('/dashboard'); }, 400);
          setTimeout(() => { history.push(data.initUrl || "/dashboard"); }, 900);
        }
      })
      .catch(function (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        showToast(error.message, true);
        if (callback) callback(null, error.message);
      });
  };
};

export const saveUserConsent = (payload, callback) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    // Unauthenticated endpoint — payload encrypted, no Authorization header
    console.log('saveUserConsent payload:', payload);
    axios
      .post('users/saveUserConsent', payload)
      .then(({ data }) => {
        if (data.success) {
          // Response is identical shape to successful login — perform full login process
          lsSet("token", data.token);
          lsSet("user", data.user);
          axios.defaults.headers.common['authorization'] = data.token;
          dispatch({ type: FETCH_SUCCESS, payload: data });
          setTimeout(() => { history.push(data.initUrl || "/dashboard"); }, 900);
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.message });
        }
        if (callback) callback(data, null);
      })
      .catch(function (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        if (callback) callback(null, error.message);
      });
  };
};


export const setSocket = (socket) => {
  return {
    type: SET_SOCKET,
    payload: socket
  };
};
